// Angular Imports
import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Output,
	booleanAttribute,
	effect,
	input,
	signal,
	viewChild,
} from '@angular/core'
// Angular Material Imports
import { MatRippleModule } from '@angular/material/core'
import { MatTooltipModule } from '@angular/material/tooltip'
// Shared Imports
import { EButtonColor, TTooltipPosition } from '@shared/models'
// Thirdparty Imports
import { Observable, debounceTime, fromEvent } from 'rxjs'

@Component({
	standalone: true,
	imports: [MatRippleModule, MatTooltipModule],
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
	readonly EButtonColor = EButtonColor

	color = input<keyof typeof EButtonColor>(EButtonColor.green)
	isOutline = input<boolean, string>(false, { transform: booleanAttribute })
	hasIcon = input<boolean, string>(false, { transform: booleanAttribute })
	isDisabled = input<boolean, boolean>(false, { transform: booleanAttribute })
	isFull = input<boolean, string>(false, { transform: booleanAttribute })
	hasTooltip = input<boolean, string>(false, { transform: booleanAttribute })
	tooltipLabel = input<string>('')
	tooltipPosition = input<TTooltipPosition>('below')
	@Output() clicked = new EventEmitter<void>()

	buttonElement = viewChild<ElementRef>('button')
	#buttonChanges!: Observable<any>

	disabledInner = signal<boolean>(false)
	#disableTime: number = 300

	constructor() {
		effect(() => {
			// console.log('button', this.buttonComponent()?.nativeElement)
			const buttonElement = this.buttonElement()?.nativeElement
			if (buttonElement) {
				this.#buttonChanges = fromEvent(buttonElement, 'click')
				this.#buttonChanges.pipe(debounceTime(this.#disableTime)).subscribe({
					next: () => {
						this.disabledInner.set(true)
						this.clicked.emit()

						setTimeout(() => {
							this.disabledInner.set(false)
						}, this.#disableTime)
					},
				})
			}
		})
	}
}
